<template>
  <div class="bg-gray-100">
    <p id="titulo-topo-pagina">
      <slot>{{ titulo }}</slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "TituloTopoDaPagina",
  props:  {
    titulo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
#titulo-topo-pagina {
  margin: 0;
  font-size: 13px;
  font-weight: 450;
  padding-left: 8px;
  padding-top: 2px;
  padding-bottom: 3px;
}
</style>
